import React from "react";
import { useSelector } from "react-redux";
import {
  MainCenter,
  ThirdContainer,
  GoToStart,
  SecondContainer,
  MainTitle,
  SecondTitle,
  ContainerHeadings,
  Bar,
  Btn,
  Arrow,
} from "./style";
import { RootState } from "../../redux/reducers/index";
import { NotFound } from "./404";
import { useRouteMatch } from "react-router-dom";
import { language } from "../../utils/language";


const Error = (props: any) => {
  const homeState: any = useSelector((state: RootState) => state.home);

  const match:any = useRouteMatch('/vende/:idCatalog');

  const basePath = `/vende/${match?.params.idCatalog}`

  const { color }: any = useSelector((state: RootState) => state.home);
  return (
    <>
      <MainCenter>
        <SecondContainer>
          <NotFound></NotFound>
          <Bar />
          <ContainerHeadings>
            <MainTitle>{language[homeState.default_language]["sorry"]}</MainTitle>
            <ThirdContainer>
              <SecondTitle>
                {language[homeState.default_language]["notFound"]}<br></br>
                {language[homeState.default_language]["searchMessage2"]}
              </SecondTitle>
              <GoToStart color={color} onClick={() => props.history.push(basePath)}>
                {language[homeState.default_language]["goHome"]}
              </GoToStart>
              <Btn
                onClick={() => props.history.push(basePath)}
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="18" cy="18" r="18" fill={color} />
              </Btn>
              <Arrow
                onClick={() => props.history.push(basePath)}
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.0586 15.9277C10.4492 15.5371 10.4102 14.9512 10.0586 14.5605L5.33203 10.0684H16.582C17.0898 10.0684 17.5195 9.67773 17.5195 9.13086V7.88086C17.5195 7.37305 17.0898 6.94336 16.582 6.94336H5.33203L10.0586 2.49023C10.4102 2.09961 10.4492 1.51367 10.0586 1.12305L9.19922 0.263672C8.84766 -0.0878906 8.22266 -0.0878906 7.87109 0.263672L0.292969 7.88086C-0.0976562 8.23242 -0.0976562 8.81836 0.292969 9.16992L7.87109 16.7871C8.22266 17.1387 8.80859 17.1387 9.19922 16.7871L10.0586 15.9277Z"
                  fill="white"
                />
              </Arrow>
            </ThirdContainer>
          </ContainerHeadings>
        </SecondContainer>
      </MainCenter>
    </>
  );
};

export default Error;
